import { RoleEntitePilotage } from "./roleEntitePilotageModel";

export class ModifierUtilisateurPilotageModel {
    constructor(
        public utilisateurId: number,
        public roleEntites: RoleEntitePilotage[],
        public numeroEmploye: string | null,
        public entiteIdAccessibles: number[],
        public etiquetteIdAccessibles: number[],
        public etiquetteIds: number[] | null,
    ) { }
}